var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudDoneOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10.0842C18.3333 5.88704 15.4219 3.33423 12 3.33423C8.76562 3.33423 6.6825 5.5936 6 7.83423C3.1875 8.11548 0.75 9.87751 0.75 13.0842C0.75 16.178 3.28125 18.3342 6.375 18.3342H18.5625C21.1406 18.3342 23.25 17.048 23.25 14.2092C23.25 11.4052 20.7656 10.1892 18.75 10.0842Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6872 10.5466L9.51184 14.1215L7.92505 11.8627",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDoneOutline);
export default __webpack_public_path__ + "static/media/cloud_done_outline.4244f3cfd31f4b4a7906e4660fb0a437.svg";
export { ForwardRef as ReactComponent };